<template>
  <div>
    <div class="flowmap-desc mr-b10">
      <ul>
        <li>· 노드 : <strong>{{ getValueAfterCheckEmpty(storeSummary.nodes) }}개</strong></li>
        <li>· 저장소 : <strong>{{ getValueAfterCheckEmpty(storeSummary.indices) }}개</strong></li>
        <li>· 총 디스크 용량 :  <strong>{{ convertByteUnit(storeSummary.diskTotal) }}</strong></li>
        <li>· 사용 디스크 용량 : <strong>{{ convertByteUnit(storeSummary.diskUsed) }}</strong></li>
        <li>· 디스크 사용률 : <strong>{{ getValueAfterCheckEmpty(!isNil(storeSummary.diskUsedPercent) ? storeSummary.diskUsedPercent.toFixed(2) : storeSummary.diskUsedPercent) }}%</strong></li>
        <li>· 총 샤드 수 :  <strong>{{ getValueAfterCheckEmpty(storeSummary.shards) }}개</strong></li>
        <li>· 미할당 샤드 수 :  <strong>{{ getValueAfterCheckEmpty(storeSummary.unassignedShards) }}개</strong></li>
      </ul>
    </div>
    <div class="mr-b30">
      디스크 사용률이 <em>85%</em>를 초과하면 오래된 저장소부터 삭제됩니다.
    </div>
    <el-row type="flex" justify="space-between">
      <el-col :span="4" class="mr-r20">
        <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
          <div class="title-h4">저장소 설정 목록</div>
          <div>
            <w-header-search-button @click="onDataindexSearchToolVisible"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper ref="indexStoreTable" :column-default="columnDefault" :columns="indexColumns" :data="usingDataindexes" :pagination="false" highlight-current-row
          :show-custom-header="true" :show-search-tool="dataindexSearchToolVisible" @current-change="onDataindexClick" row-class-name="c-pointer">
        </el-table-wrapper>
      </el-col>
      <el-col :span="20">
        <el-tabs class="tab-button" v-model="activeButtonTab">
          <el-tab-pane label="저장소 목록" name="index">
            <w-index-table ref="indexTable" :selected-dataindex="selectedDataindex"  :is-progressed-restore="isProgressedRestore"
              @update-snapshot="onUpdateSnapshot" @change-snapshot-state="changeSnapshotState"></w-index-table>
          </el-tab-pane>
          <el-tab-pane label="백업 목록" name="snapshot">
            <w-snapshot-table ref="snapshotTable" :selected-dataindex="selectedDataindex" :is-progressed-snapshot="isProgressedSnapshot"
              @update-index="onUpdateIndex" @change-restore-state="changeRestoreState"></w-snapshot-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';

import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import LogStoreAPI from '@/api/log/log-store';

import WIndexTable from './IndexTable';
import WSnapshotTable from './SnapshotTable';

export default {
  name: 'WLogIndexStore',
  components: {
    WIndexTable,
    WSnapshotTable,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      indexColumns: [
        {
          label: '저장소 이름',
          prop: 'dataindexName',
          searchable: true,
          sortable: true,
        },
      ],
      usingDataindexes: [],
      storeSummary: {},
      columnDefault,
      dataindexSearchToolVisible: false,
      selectedDataindex: {},
      activeButtonTab: 'index',
      isProgressedRestore: false,
      isProgressedSnapshot: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    isNil,
    /**
     * 저장소 설정 목록과 저장소 요약 정보를 조회해온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      this.activeButtonTab = 'index';
      LogStoreAPI.getStoreSummary().then((response) => {
        if (response.data.success) {
          this.storeSummary = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '저장소 요약 정보', false));
        throw new Error(e);
      });
      LogStoreAPI.getDataindexes().then((response) => {
        if (response.data.success) {
          this.usingDataindexes = response.data.data;
          this.$refs.indexStoreTable.$children[0].setCurrentRow(this.usingDataindexes[0]);
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '저장소 설정', false));
        throw new Error(e);
      });
    },
    changeSnapshotState(isProgressedSnapshot) {
      this.isProgressedSnapshot = isProgressedSnapshot;
    },
    changeRestoreState(isProgressedRestore) {
      this.isProgressedRestore = isProgressedRestore;
    },
    convertByteUnit(value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return `${convertValuByUnit(value, 'B', false, false, true)}B`;
    },
    getValueAfterCheckEmpty,
    onDataindexSearchToolVisible() {
      this.dataindexSearchToolVisible = !this.dataindexSearchToolVisible;
    },
    /**
     * 저장소 설정 목록의 row를 선택했을 때 발생하는 이벤트 함수
     * @author Minyeong
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onDataindexClick(row) {
      this.selectedDataindex = row;
    },
    onUpdateIndex() {
      this.$refs.indexTable.loadIndices(this.selectedDataindex.dataindexOrigin);
    },
    onUpdateSnapshot() {
      this.$refs.snapshotTable.loadData(this.selectedDataindex.dataindexOrigin);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/popup/store/LogIndexStore.vue